import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { SharedModule } from '../shared/shared.module';
// import { ProductsModule } from './../portal/products/products.module';
import { UtilsModule } from './../utils/utils.module';
import { FormElementModule } from '../portal/product-signup/form-element/form-element.module';
import { AccountComponent } from './account.component';
import { AccountRoutes } from './account.routing';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { CaptchaComponent } from './captcha/captcha.component';
import { ForgotPasswordSignUpComponent } from './forgot-password-sign-up/forgot-password-sign-up.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { AdminChangePasswordComponent } from './admin-change-password/admin-change-password.component';
import { AdminResetPasswordComponent } from './admin-reset-password/admin-reset-password.component';
import { TranslateModule } from '@ngx-translate/core';
import { HeroSliderComponent } from '../hero-slider/hero-slider.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    RouterModule.forChild(AccountRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    // ProductsModule,
    DropDownsModule,
    TranslateModule,
    FormElementModule,
    HeroSliderComponent,
  ],
  exports: [SignUpComponent, LoginComponent, ForgotPasswordComponent, ForgotPasswordSignUpComponent, AccountComponent],
  declarations: [
    AccountComponent,
    LoginComponent,
    AdminLoginComponent,
    AdminChangePasswordComponent,
    AdminResetPasswordComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ForgotPasswordSignUpComponent,
    CaptchaComponent,
  ],
})
export class AccountModule {}
// export * from './account.component';
// export * from './forgot-password/forgot-password.component';
